(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["ambrosia-hero"]) return;
  try {
    
    jQuery(document).ready(function($){
        $(document).on( 'click', 'form.order-now-form input[type=submit],form.order-now-form button', function(e){
            var $form = $(this).closest('form');
            $form.find('select,input').each( function(){
                if( !$(this).val() ) {
                    $(this).addClass('invalid');
                } else {
                    $(this).removeClass('invalid');
                }
            })
            if( $form.find('.invalid').length ) {
                if( $form.find('.messages').length == 0 ) $form.append('<div class="messages"></div>');
                var msg = '<div class="alert alert-danger">Please fill in all fields</div>';
                $form.find('.messages').html(msg);
                e.preventDefault();
                return false;
            }
        });
        $(document).on('change','.invalid',function(){
            $(this).removeClass('invalid');
        })
        localStorage.setItem( 'discountCode', $('input[name=discount]').val() );
        console.log('discount is:',localStorage.getItem('discountCode'));
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  jQuery(document).ready( function($) {
    var discount = localStorage.getItem( 'discountCode' );
    if( discount ) $('[name=discount]').val(discount);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keg-hero"]) return;
  try {
    
    jQuery(document).ready(function($){
        $(document).on( 'click', 'form.order-now-form input[type=submit],form.order-now-form button', function(e){
            var $form = $(this).closest('form');
            $form.find('select,input').each( function(){
                if( !$(this).val() ) {
                    $(this).addClass('invalid');
                } else {
                    $(this).removeClass('invalid');
                }
            })
            if( $form.find('.invalid').length ) {
                if( $form.find('.messages').length == 0 ) $form.append('<div class="messages"></div>');
                var msg = '<div class="alert alert-danger">Please fill in all fields</div>';
                $form.find('.messages').html(msg);
                e.preventDefault();
                return false;
            }
        });
        $(document).on('change','.invalid',function(){
            $(this).removeClass('invalid');
        })
        localStorage.setItem( 'discountCode', $('input[name=discount]').val() );
        console.log('discount is:',localStorage.getItem('discountCode'));
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keg-hero2"]) return;
  try {
    
    jQuery(document).ready(function($){
        $(document).on( 'click', 'form.order-now-form input[type=submit],form.order-now-form button', function(e){
            var $form = $(this).closest('form');
            $form.find('select,input').each( function(){
                if( !$(this).val() ) {
                    $(this).addClass('invalid');
                } else {
                    $(this).removeClass('invalid');
                }
            })
            if( $form.find('.invalid').length ) {
                if( $form.find('.messages').length == 0 ) $form.append('<div class="messages"></div>');
                var msg = '<div class="alert alert-danger">Please fill in all fields</div>';
                $form.find('.messages').html(msg);
                e.preventDefault();
                return false;
            }
        });
        $(document).on('change','.invalid',function(){
            $(this).removeClass('invalid');
        })
        localStorage.setItem( 'discountCode', $('input[name=discount]').val() );
        console.log('discount is:',localStorage.getItem('discountCode'));
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-hero"]) return;
  try {
    
    jQuery(document).ready(function($){
        $(document).on( 'click', 'form.order-now-form input[type=submit],form.order-now-form button', function(e){
            var $form = $(this).closest('form');
            $form.find('select,input').each( function(){
                if( !$(this).val() ) {
                    $(this).addClass('invalid');
                } else {
                    $(this).removeClass('invalid');
                }
            })
            if( $form.find('.invalid').length ) {
                if( $form.find('.messages').length == 0 ) $form.append('<div class="messages"></div>');
                var msg = '<div class="alert alert-danger">Please fill in all fields</div>';
                $form.find('.messages').html(msg);
                e.preventDefault();
                return false;
            }
        });
        $(document).on('change','.invalid',function(){
            $(this).removeClass('invalid');
        })
        localStorage.setItem( 'discountCode', $('input[name=discount]').val() );
        console.log('discount is:',localStorage.getItem('discountCode'));
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.runMultiCurrency();
      $(window).trigger('checkcaptionheights');
      theme.checkForRevealElements();
      // Shopify reviews app
      if(window.SPR && SPR.initDomEls && SPR.loadBadges) {
        SPR.initDomEls();
        SPR.loadBadges();
      }
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

})();
